
import { createRouter, createWebHistory } from 'vue-router'

import NotFound from '@/views/NotFound/NotFound.vue'
import Home from '@/views/Home/Home.vue'
// import Review from '@/views/Review/Review.vue'
// import UploadDT from '@/views/UploadDT/UploadDT.vue'
// import Upload from '@/views/Upload/Upload.vue'
import Authentication from '@/views/Authentication/Authentication.vue'

const routes = [{
    path: '/',
    name: 'home',
    component: Home,
    meta: { layout: 'DefaultLayout' }
}, {
    path: '/authentication',
    name: 'authentication',
    component: Authentication,
    meta: { layout: 'DefaultLayout' }
}
// , {
//     path: '/review',
//     name: 'review',
//     component: Review,
//     meta: { layout: 'DefaultLayout' }
// }, {
//     path: '/upload-dt',
//     name: 'upload-dt',
//     component: UploadDT,
//     meta: { layout: 'DefaultLayout' }
// }, {
//     path: '/upload',
//     name: 'upload',
//     component: Upload,
//     meta: { layout: 'DefaultLayout' }
// }
, {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: NotFound,
    meta: { layout: 'EmptyLayout' }
}]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
})

export default router
